import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import config from "../../../config";
import { useSelector } from "react-redux";
import { BookingMembershipOptions, BookingSelectedMembershipData, BookingSelectedServicesData, NextStep, PreviewStep } from "store/slices/bookingSlice";
import { useDispatch } from "react-redux";
import ApiStatus from "component/ApiStatus";
import BookingStep6 from "./Step3";
import { Elements } from "@stripe/react-stripe-js";
import getStripeClient from "pages/getStripeClient";

const MemebershipStep2 = (props) => {
  const [hidden, setHidden] = useState({});
  const stripePromise = getStripeClient();

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isBookingStep = props.isBookingStep;
  const isBookingApi = useSelector((state) => state.booking.isBookingApi);
  const isMembershipOption = useSelector((state) => state.booking.isMembershipOption);
  const [makePaymentinfoShow, setMakePaymentinfoShow] = useState("hide");
    const isBookingSelectedMembershipData = useSelector((state) => state.booking.isBookingSelectedMembershipData);
  
  const objectData = isMembershipOption && isMembershipOption.data && isMembershipOption.data.length > 0 ? isMembershipOption.data : isMembershipOption;
  const objectDataWithout = objectData;
  useEffect(() => {
    dispatch(BookingMembershipOptions({ uid: isBookingApi && isBookingApi.uid, salon_id: isBookingApi && isBookingApi.salon && isBookingApi.salon.id }));
  }, []);
  const toggleHide = (index) => {
    setHidden({ ...hidden, [index]: !hidden[index] });
  };

  return (
    <>
      {makePaymentinfoShow === "hide" ? (
        <React.Fragment>
          {/* <div className="please-sele">
          <a
            role="button"
            onClick={() => {
              dispatch(PreviewStep(isBookingStep));
            }}
          >
            <img src={config.imagepath + "left-arrow.svg"} alt="" className="me-3" width="21" />
            {t("Please select a Package")}
          </a>
        </div> */}
          <div className="items-list">
            <ul className="m-0 p-0">
              {objectDataWithout && objectDataWithout.length > 0 ? (
                Object.keys(objectDataWithout).map((item, i) => {
                  let id = objectDataWithout[item].id;
                  let name = objectDataWithout[item].name;
                  let description = objectDataWithout[item].description;
                  let cost = objectDataWithout[item].cost;
                  let credit = objectDataWithout[item].credit;
                  let subservice = objectDataWithout[item].subservice;
                  let services = [];
                  subservice &&
                    subservice.forEach((item) => {
                      services.push(item.services.name);
                    });
                  let implodeservices = services.join(", ");
                  let activeClass = "";
                  return (
                    <li className={"items-option " + activeClass} key={i}>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6
                          className="mb-0"
                          role="button"
                          onClick={() => {
                            dispatch(BookingSelectedMembershipData(objectDataWithout[item]));
                            setMakePaymentinfoShow("show");
                            // dispatch(NextStep(isBookingStep));
                          }}
                        >
                          <a>{name}</a>
                        </h6>
                        <div>
                          <a className="fw-semibold me-3">${cost}</a>
                          <a className="" role="button" onClick={() => toggleHide(id)}>
                            <img className="" src={config.imagepath + "info.svg"} alt="info" />
                          </a>
                        </div>
                      </div>
                      {!!hidden[id] && (
                        <div>
                          <p className="m-0">{`${description} - ${t("receive ${{ credit }} credit for just ${{ cost }}!", { credit: credit, cost: cost })}`}</p>
                          <p className="m-0">{services && t("Redeemable on the following services") + " : " + implodeservices}</p>
                          <a role="button" onClick={() => toggleHide(id)} className="text-primary">
                            <u>{t("Hide")}</u>
                          </a>
                        </div>
                      )}
                    </li>
                  );
                })
              ) : (
                <ApiStatus actionType="BookingMembershipOptions" />
                // <li className="fw-bold items-option nodatafound">{t("No data found")}</li>
              )}
            </ul>
          </div>
        </React.Fragment>
      ) : (
        <Elements stripe={stripePromise}>
          <BookingStep6 setMakePaymentinfoShow={setMakePaymentinfoShow} isBookingStep={isBookingStep} bookingStepName={'BuyMembership'} isBookingSelectedMembershipData={isBookingSelectedMembershipData}  />
        </Elements>

      )}</>


  );
};

MemebershipStep2.propTypes = {
  isBookingStep: PropTypes.number,
};
export default MemebershipStep2;
